export default __webpack_public_path__ + "static/zeiss_logo.inline-cebafe2c5fd37b68628c27302b9fa4a7.png";